import { OrganisationMin } from 'models';

import { API_URL } from 'config';
import { makeAPICall } from './api';

import { Antenna, mapAPIToAntenna, API as AntennaAPI } from './antennas';
import {
    Satellite,
    mapAPIToSatellite,
    API as SatelliteAPI,
} from './satellites';

export declare namespace API {
    export interface SchedulePlan {
        id: number;
        organisation: OrganisationMin;
        name: string;
        antenna: AntennaAPI.Antenna[];
        satellite: SatelliteAPI.Satellite[];
        priority: number;
        start_time: string;
        stop_time: string;
        enabled: boolean;
        created: string;
        require_confirmation: boolean;
        min_access_time: number;
        max_access_time: number;
        desired_daily_duration: number;
        band_name: string;
    }

    export interface SchedulePlanOverview {
        id: number;
        organisation: OrganisationMin;
        name: string;
        antenna: number[];
        priority: number;
        start_time: string;
        stop_time: string;
        enabled: boolean;
        created: string;
        require_confirmation: boolean;
        min_access_time: number;
        max_access_time: number;
        desired_daily_duration: number;
        band_name: string;
    }
}

export interface SchedulePlan {
    id: number;
    organisation: OrganisationMin;
    name: string;
    antenna: Antenna[];
    satellite: Satellite[];
    priority: number;
    start_time: Date;
    stop_time: Date;
    enabled: boolean;
    created: Date;
    require_confirmation: boolean;
    min_access_time: number;
    max_access_time: number;
    desired_daily_duration: number;
    band_name: string;
}

export interface SchedulePlanOverview {
    id: number;
    organisation: OrganisationMin;
    name: string;
    antenna: number[];
    priority: number;
    start_time: Date;
    stop_time: Date;
    enabled: boolean;
    created: Date;
    require_confirmation: boolean;
    min_access_time: number;
    max_access_time: number;
    desired_daily_duration: number;
    band_name: string;
}

const SCHEDULEPLANS_ROUTE = '/scheduleplans';

export const mapAPIToSchedulePlan = ({
    created,
    start_time,
    stop_time,
    antenna,
    satellite,
    ...rest
}: API.SchedulePlan): SchedulePlan => ({
    ...rest,
    antenna: antenna.map((a) => mapAPIToAntenna(a)),
    satellite: satellite.map((s) => mapAPIToSatellite(s)),
    start_time: new Date(start_time),
    stop_time: new Date(stop_time),
    created: new Date(created),
});

export const mapAPIToSchedulePlanOverview = ({
    created,
    start_time,
    stop_time,
    ...rest
}: API.SchedulePlanOverview): SchedulePlanOverview => ({
    ...rest,
    start_time: new Date(start_time),
    stop_time: new Date(stop_time),
    created: new Date(created),
});

export const listSchedulePlans = makeAPICall<
    SchedulePlan[],
    void,
    { results: API.SchedulePlan[] }
>(
    () => ({
        url: `${API_URL}${SCHEDULEPLANS_ROUTE}/`,
    }),
    (data) => data.results.map(mapAPIToSchedulePlan),
);
